document.querySelectorAll('[data-header-behaviour="fixed"], [data-header-behaviour="disappear"]').forEach((header) => {
  const behaviour = header.dataset.headerBehaviour;
  const announcementBar = document.querySelector('.announcement-bar');
  const stack = announcementBar ? [announcementBar, header] : [header];

  let stackHeight = 0;
  let hidden = false;
  const heights = new Map();

  // --sticky-header-visible is how much of the header is on screen right now
  // (0 while a "disappear" header is slid away), for sticky elements that
  // should move up into the space it leaves instead of leaving a gap.
  // --sticky-header-offset stays the full height, for layout maths.
  const publishVisible = () => {
    document.documentElement.style.setProperty('--sticky-header-visible', `${hidden ? 0 : stackHeight}px`);
  };

  const layout = () => {
    // Heights come from the ResizeObserver below, which reports them after the
    // browser's own layout pass - reading offsetHeight here instead would force
    // a synchronous reflow while the page is still loading. Heights are
    // unaffected by position: fixed on a full-width bar.
    let offset = 0;
    stack.forEach((el) => {
      el.style.position = 'fixed';
      el.style.insetInlineStart = '0';
      el.style.insetInlineEnd = '0';
      el.style.top = `${offset}px`;
      el.style.zIndex = '50';
      offset += heights.get(el) || 0;
    });
    stackHeight = offset;
    document.body.style.paddingTop = `${stackHeight}px`;
    // Exposed so other sections (e.g. a sticky sidebar) can offset
    // themselves below the fixed/disappearing header group without
    // duplicating this measurement.
    document.documentElement.style.setProperty('--sticky-header-offset', `${stackHeight}px`);
    publishVisible();
  };

  // Fires once per element straight after the first layout, then again
  // whenever a bar's height changes (resize, web fonts loading, wrapping),
  // which replaces a window resize listener.
  const observer = new ResizeObserver((entries) => {
    entries.forEach((entry) => {
      const box = entry.borderBoxSize && entry.borderBoxSize[0];
      heights.set(entry.target, box ? box.blockSize : entry.target.offsetHeight);
    });
    layout();
  });
  stack.forEach((el) => observer.observe(el));

  if (behaviour !== 'disappear') return;

  stack.forEach((el) => {
    el.style.transition = 'transform 0.3s ease';
  });

  const threshold = 10;
  let lastScrollY = window.scrollY;
  let mobileMenuOpen = false;

  const setHidden = (state) => {
    if (state === hidden) return;
    hidden = state;
    const transform = hidden ? `translateY(-${stackHeight}px)` : 'translateY(0)';
    stack.forEach((el) => {
      el.style.transform = transform;
    });
    publishVisible();
  };

  document.addEventListener('header:mobile-menu-toggle', (event) => {
    mobileMenuOpen = event.detail.open;
    if (mobileMenuOpen) {
      setHidden(false);
    } else {
      lastScrollY = window.scrollY;
    }
  });

  window.addEventListener(
    'scroll',
    () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 0) {
        setHidden(false);
      } else if (currentScrollY > lastScrollY + threshold) {
        if (!mobileMenuOpen) setHidden(true);
        lastScrollY = currentScrollY;
      } else if (currentScrollY < lastScrollY - threshold) {
        setHidden(false);
        lastScrollY = currentScrollY;
      }
    },
    { passive: true }
  );
});
